import React from 'react'

import { Card } from '@Common/Components'
import state from '../../../State'
import { Flight } from './Elements'
import PlusButton from '../PlusButton'
import { updateService, deleteService } from '../../../Functions'

export default function FlightForm () {
  const [flightForm] = state.flightForm.useState()

  if (!flightForm?.length) return null

  return (
    <Card
      key='flight'
      title='VOLO'
      collapsable={flightForm.length > 0}
      style={{ marginBottom: '20px', width: '100%' }}
    >
      <PlusButton type='flightForm' />
      {flightForm.map((item, index) => (
        <Flight
          key={index}
          index={index}
          item={item}
          onUpdate={updateService}
          onDelete={deleteService}
        />
      ))}
    </Card>
  )
}
